import React, { useEffect } from 'react'
import Brandlogo from './BrandLogo'
import ProfileCard from './ProfileCard'
import "./style.scss"
import { useDispatch, useSelector } from 'react-redux'
import { profileSettings } from '../../redux/reducers/profileSettingReducer'
import { useAuth } from '../hooks/useAuth'
export default function HeaderComp() {
  let dispatch = useDispatch();
  let { isSignedin } = useAuth();
  const distributorDetails = useSelector(
    (state) => state.profileSettings?.getDistributorDetailReq?.response || []
  );
  useEffect(() => {
    if(!distributorDetails?.length){
      dispatch(profileSettings({dispatch}));
    }
  },[dispatch,distributorDetails?.length]);
  return (
    <div className='headerComp'>
        <Brandlogo/>
        {isSignedin ? <ProfileCard /> : <></>}
    </div>
  )
}
